import { Component, Input } from '@angular/core';

export interface AbstractButtonConfig<Choice>
{
  labelKey: string;
  choice: Choice;
}

export enum Choice
{
  OK,
  RETRY,
  IGNORE,
  CANCEL,
  CONTINUE,
}

type ButtonConfig = AbstractButtonConfig<Choice>;

export class Button {
  public static Choice: any = Choice;

  public static readonly OK: ButtonConfig = {
    labelKey: 'i18n.button.ok',
    choice: Choice.OK,
  };

  public static readonly RETRY: ButtonConfig = {
    labelKey: 'i18n.button.retry',
    choice: Choice.RETRY,
  };

  public static readonly IGNORE: ButtonConfig = {
    labelKey: 'i18n.button.ignore',
    choice: Choice.IGNORE,
  };

  public static readonly CANCEL: ButtonConfig = {
    labelKey: 'i18n.button.cancel',
    choice: Choice.CANCEL,
  };

  public static readonly CONTINUE: ButtonConfig = {
    labelKey: 'i18n.button.continue',
    choice: Choice.CONTINUE,
  };

  public static readonly IGNORE_AND_CONTINUE: ButtonConfig = {
    labelKey: 'i18n.button.ignoreAndContinue',
    choice: Choice.IGNORE,
  };

  public static readonly CANCEL_AND_FIX: ButtonConfig = {
    labelKey: 'i18n.button.cancelAndFix',
    choice: Choice.CANCEL,
  };

  public static readonly WITHOUT_SMART_SORTED: ButtonConfig = {
    labelKey: 'i18n.button.withoutSmartSorted',
    choice: Choice.CONTINUE,
  };

  public static readonly WITH_SMART_SORTED: ButtonConfig = {
    labelKey: 'i18n.button.withSmartSorted',
    choice: Choice.OK,
  };
}

export interface ButtonsAssignment {
  primary?: AbstractButtonConfig<any>;
  secondary?: AbstractButtonConfig<any>;
}

@Component({
    selector: 'dialog-buttons',
    templateUrl: './dialog-buttons.component.html',
    styleUrls: ['./dialog.scss'],
    standalone: false
})
export class DialogButtonsComponent
{
  @Input() public buttons: ButtonsAssignment;
}
